import produce from "immer";
import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGOUT,
	SILENT_LOGIN,
	SET_QUERY_ME,
	SET_CURRENT_BROKER,
	SET_BROKER,
} from "src/actions/accountActions";
import { accountAction, accountState } from "./types/accountTypes";

const initialState: accountState = {
	user: undefined,
	broker: undefined,
	refetcher: {},
};

function delete_cookie(name: string) {
	document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

const accountReducer = (
	state: accountState = initialState,
	action: accountAction
): accountState => {
	switch (action.type) {
		case LOGIN_REQUEST: {
			return produce(state, (draft) => {
				draft.user = undefined;
			});
		}
		case LOGIN_SUCCESS: {
			const me = action.payload;
			return produce(state, (draft) => {
				draft.user = me;
			});
		}

		case LOGOUT: {
			return produce(state, (draft) => {
				delete_cookie("access_token");
				// window.location.reload();
				draft.user = undefined;
			});
		}

		case SILENT_LOGIN: {
			const me = action.payload;
			return produce(state, (draft) => {
				draft.user = me;
			});
		}

		case SET_QUERY_ME: {
			const { queryMe } = action.payload;
			return produce(state, (draft) => {
				draft.refetcher.me = queryMe;
			});
		}

		case SET_CURRENT_BROKER: {
			const { broker } = action.payload;
			return produce(state, (draft) => {
				draft.broker = broker;
			});
		}

		case SET_BROKER : {
			const { broker } = action.payload;
			return produce(state, (draft) => {
				// if (draft.broker?.broker) {
				// 	draft.broker.broker = broker;
				// }
				draft.broker = {
					broker : broker,
					brokerUsername : draft.broker?.brokerUsername || ""
				}
			});
		}

		default: {
			return state;
		}
	}
};

export default accountReducer;
